import { useEffect } from "react";

const HomepageAccordionWidget: React.FC = () => {
  useEffect(() => {
    function homepageAccordionUI() {
      const homepageAccordions = document.querySelectorAll(".homepage-accordion");
      homepageAccordions.forEach((homepageAccordion) => {
        homepageAccordion.addEventListener("click", function () {
          const accordionElement = homepageAccordion as HTMLElement;
          if (accordionElement.classList.contains("active")) {
            if (accordionElement.classList.contains("homepage-accordion-last")) {
              accordionElement.style.position = "absolute";
            }

            const closeAccordion = (element: HTMLElement) => {
              element.style.zIndex = "1";
              const button = element.querySelector(".homepage-accordion-button");
              if (button) {button.innerHTML = "+";}
              element.style.position = "relative";
            }
            setTimeout(closeAccordion, 200, accordionElement);
          } else {
            accordionElement.style.zIndex = "100";

            homepageAccordions.forEach((homepageAccordion) => {
              const otherAccordionElement = homepageAccordion as HTMLElement;
              if (otherAccordionElement.classList.contains("active")) {
                otherAccordionElement.classList.remove("active");
                const button = otherAccordionElement.querySelector(".homepage-accordion-button");
                if (button) {button.innerHTML = "+";}
                otherAccordionElement.style.zIndex = "1";
              }
            });

            const openAccordion = (element: HTMLElement) => {
              const button = element.querySelector(".homepage-accordion-button");
              if (button) {button.innerHTML = "-";}
            }
            setTimeout(openAccordion, 200, accordionElement);
          }

          accordionElement.classList.toggle("active");
        });
      });
    }

    function cogentResize() {
      const winWidth = window.innerWidth;
      if (winWidth > 767) {
        cogentMosaic();
      }
    }

    function cogentMosaic() {
      let rightHeight = 0;
      let leftColumnHeight = 0;

      const leftColumnGrids = document.querySelectorAll(".left-column .grid");
      leftColumnGrids.forEach((leftColumnGrid) => {
        const columnGrid = leftColumnGrid as HTMLElement;
        leftColumnHeight += columnGrid.offsetHeight;
      });

      rightHeight = leftColumnHeight / 2 + 0.5;

      const rightColumnGrids = document.querySelectorAll(".right-column .grid");
      rightColumnGrids.forEach((rightColumnGrid) => {
        const columnGrid = rightColumnGrid as HTMLElement;
        columnGrid.style.height = `${rightHeight}px`;
      });
    }

    const logoLink = document.querySelector(".logo a");
    logoLink?.addEventListener("click", function () {
      setTimeout(() => {
        cogentResize();
        homepageAccordionUI();
      }, 250);
    });

    let windowWidth = window.innerWidth;
    window.addEventListener("resize", () => {
      setTimeout(() => {
        windowWidth = window.innerWidth;
        cogentResize();
      }, 250);
    });

    // Wait for all images to load inside class homepage-hero-mosaic
    function waitForImagesToLoad() {
        const images = document.querySelectorAll(".homepage-hero-mosaic img") as NodeListOf<HTMLImageElement>;
        let loadedImages = 0;
  
        images.forEach((img) => {
          if (img.complete) {
            loadedImages += 1;
          } else {
            img.addEventListener("load", () => {
              loadedImages += 1;
              if (loadedImages === images.length) {
                cogentResize(); // All images loaded, trigger the logic
              }
            });
          }
        });
  
        if (loadedImages === images.length) {
          cogentResize(); // All images are already loaded
        }
      }
  
      waitForImagesToLoad();
      homepageAccordionUI();
  
      // Clean up
      return () => {
        const images = document.querySelectorAll(".homepage-hero-mosaic img");
        images.forEach((img) => img.removeEventListener("load", () => {}));
      };
      
  }, []); // Empty dependency array ensures the effect runs once on mount

  return null; // This component handles logic only
};

export default HomepageAccordionWidget;
